import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useTranslations } from 'next-intl';
import { FaApple, FaCircleCheck, FaEnvelope, FaGoogle, FaHouseUser, FaLinkedin, FaMobileButton, FaSquareFacebook, FaSquareInstagram, FaUser } from 'react-icons/fa6';
import { type Listing, type ListingWithUser } from '@/features/listing/types/listing-types';
import { VerificationStatus } from '@/features/user/types/user-id-verification-types';
import styles from './listing-verifications.module.scss';
interface ListingVerificationsProps {
  userVerifications: ListingWithUser['user']['verifications'];
  isAddressVerified?: Listing['addressVerificationStatus'];
  isProfilePage?: boolean;
  showOnlyImportant?: boolean;
  showText?: boolean;
}
export default function ListingVerifications(props) {
  const $ = _c(35);
  const {
    isAddressVerified,
    isProfilePage,
    showOnlyImportant,
    showText: t0,
    userVerifications
  } = props;
  const showText = t0 === undefined ? true : t0;
  const translationsVerifications = useTranslations("global.verifications");
  const t1 = isProfilePage && styles.listingVerifications__isProfilePage;
  const t2 = !showText && styles.listingVerifications__withoutText;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cx(styles.listingVerifications, t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showText || $[4] !== translationsVerifications || $[5] !== userVerifications.id?.status) {
    t4 = userVerifications.id?.status === VerificationStatus.Passed && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaUser className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>{translationsVerifications("id-checked")}</p>}</div>;
    $[3] = showText;
    $[4] = translationsVerifications;
    $[5] = userVerifications.id?.status;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isAddressVerified || $[8] !== showText || $[9] !== translationsVerifications) {
    t5 = isAddressVerified === VerificationStatus.Passed && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaHouseUser className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>{translationsVerifications("address-checked")}</p>}</div>;
    $[7] = isAddressVerified;
    $[8] = showText;
    $[9] = translationsVerifications;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== showText || $[12] !== translationsVerifications || $[13] !== userVerifications.email) {
    t6 = userVerifications.email && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaEnvelope className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>{translationsVerifications("email-validated")}</p>}</div>;
    $[11] = showText;
    $[12] = translationsVerifications;
    $[13] = userVerifications.email;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== showText || $[16] !== translationsVerifications || $[17] !== userVerifications.phone) {
    t7 = userVerifications.phone && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaMobileButton className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>{translationsVerifications("phone-validated")}</p>}</div>;
    $[15] = showText;
    $[16] = translationsVerifications;
    $[17] = userVerifications.phone;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== showOnlyImportant || $[20] !== showText || $[21] !== translationsVerifications || $[22] !== userVerifications.apple || $[23] !== userVerifications.facebook || $[24] !== userVerifications.google || $[25] !== userVerifications.instagram || $[26] !== userVerifications.linkedIn) {
    t8 = !showOnlyImportant && <>{userVerifications.apple && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaApple className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>Apple{" "}{translationsVerifications("validated")}</p>}</div>}{userVerifications.google && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaGoogle className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>Google{" "}{translationsVerifications("validated")}</p>}</div>}{userVerifications.facebook && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaSquareFacebook className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>Facebook{translationsVerifications("validated")}</p>}</div>}{userVerifications.instagram && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaSquareInstagram className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>Instagram{translationsVerifications("validated")}</p>}</div>}{userVerifications.linkedIn && <div className={styles.listingVerifications_item}><div className={styles.listingVerifications_status}><FaCircleCheck className={styles.listingVerifications_checked} /><FaLinkedin className={styles.listingVerifications_icon} /></div>{showText && <p className={styles.listingVerifications_text}>LinkedIn{translationsVerifications("validated")}</p>}</div>}</>;
    $[19] = showOnlyImportant;
    $[20] = showText;
    $[21] = translationsVerifications;
    $[22] = userVerifications.apple;
    $[23] = userVerifications.facebook;
    $[24] = userVerifications.google;
    $[25] = userVerifications.instagram;
    $[26] = userVerifications.linkedIn;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
    t9 = <div className={t3}>{t4}{t5}{t6}{t7}{t8}</div>;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
}